import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

export const linkCellRendererFactory = <T, >(getUrl: (value: string, data: T) => string) => {
  const LinkCellRenderer = ({
    data,
    value,
  }: {
    data: T,
    value: string,
  }) => {
    const url = useMemo(() => getUrl(value, data), [value, data]);

    return (
      <Link to={url}>
        {value}
      </Link>
    );
  };

  return LinkCellRenderer;
};
